interface DisplayOrganization {
    brandName?: string | null;
    name?: string | null;
    id?: string | null;
}

export function getOrganizationDisplayName(organization?: DisplayOrganization | null): string {
    return organization?.brandName?.trim() || organization?.name?.trim() || organization?.id?.trim() || 'Organization';
}
